import { cls } from "@fvilers/cls";
import { ComponentProps } from "react";
import { useFieldContext } from "../../../hooks/useAppForm";
import { Switch } from "../../Switch/Switch";
import { SwitchLabel } from "../../Switch/SwitchLabel";
import filtersStyles from "../Filters.module.css";
import styles from "./OptionalFilterCard.module.css";

export type OptionalFilterCardProps = {
  className?: string;
  form?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement, HTMLInputElement>,
  ) => void;
  open: boolean;
  summary: string;
} & Omit<ComponentProps<"div">, "onChange">;

export function OptionalFilterCard({
  children,
  className,
  form,
  onChange,
  open,
  summary,
  ...props
}: OptionalFilterCardProps) {
  return (
    <div
      className={cls(
        filtersStyles.FiltersCard,
        styles.OptionalFilterCard,
        className,
      )}
      {...props}
    >
      <SwitchLabel
        className={styles.OptionalFilterLabel}
        label={summary}
        placement="start"
      >
        <Switch checked={open} form={form} onChange={onChange} />
      </SwitchLabel>
      <div
        className={cls(styles.OptionalFilterContent, !open && styles.hidden)}
      >
        {children}
      </div>
    </div>
  );
}

export function OptionalFilterCardField(
  props: Omit<OptionalFilterCardProps, "onChange" | "open">,
) {
  const field = useFieldContext<boolean>();
  return (
    <OptionalFilterCard
      {...props}
      form={field.form.formId}
      onBlur={field.handleBlur}
      onChange={(e) => field.handleChange(e.target.checked)}
      open={field.state.value}
    />
  );
}
